import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../../utils/PrivateRoute";

import PageNotFound from "../shared/components/notices/PageNotFound";
import Account from "./containers/Account";


class AccountRoutes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute exact path="/account" component={Account} />
        <Route component={PageNotFound} />
      </Switch>
    )
  }
}

export default AccountRoutes;



// WEBPACK FOOTER //
// ./src/features/account/routes.js